<template>
  <div>
    <a-table
      :columns="columns"
      :loading="loadingSummary"
      :data-source="reportsSummary"
      :pagination="false"
      :scroll="{ x: true }"
      :row-key="(report) => report.id"
    >
      <template #user="text, record">
        <span class="d-flex align-items-center">
          <a-avatar :src="record.gravatar" size="small" class="mr-2" />
          <router-link :to="{ name: 'user', params: { id: record.user_id } }">
            {{ text }}
          </router-link>
        </span>
      </template>

      <template #footer>
        <strong>Project total:</strong>
        {{ projectTotalHours }}h
      </template>
    </a-table>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";

// Props
const props = defineProps({
  reportsSummary: { type: Array as () => Array<any>, default: () => [] },
  loadingSummary: { type: Boolean, default: false },
});

// Data properties
const columns = ref<Array<any>>([
  {
    title: "User",
    dataIndex: "name",
    key: "user",
    scopedSlots: { customRender: "user" },
  },
  {
    title: "Role",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "Total hours",
    dataIndex: "total",
    key: "total",
  },
  {
    title: "Expected hours",
    dataIndex: "expected_hours",
    key: "expected_hours",
  },
  {
    title: "Total Cost",
    dataIndex: "total_cost_cents",
    key: "total_cost",
    customRender: (text: number, record: { total_cost_currency: string }) => {
      if (!text) {
        return "";
      }
      return (text / 100).toString() + " " + record.total_cost_currency;
    },
  },
]);

// Computed properties
const projectTotalHours = computed((): number => {
  let total = 0;
  for (let role of props.reportsSummary) {
    total += role.total;
  }
  return total;
});
</script>
